import actions from '@/core/store/pedido/documentos/processo-digital/desentranhamento/actions'

export default {
	actions,
}
